module.exports = __webpack_public_path__ + "static/media/fb.1b3ba328.png";